import { i18n, inject, pr, React, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { MessageScreen } from "../common/MessageScreen";
import { SurveyStore } from "./SurveyStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: SurveyStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore", "authStore")
export class SurveySuccess extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                message={ui.__("survey.success.message")}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/survey/SurveySuccess.tsx